export default __webpack_public_path__ + "static/media/046-electric kettle.c6d96bfe.svg";